import { combineReducers } from 'redux';
import { entities } from './entities';
import { availableList } from './available-list';

const benchmarks = combineReducers({
  availableList,
  entities,
});

export { benchmarks };
